import React, { useRef, useCallback, useState } from 'react';
import { formatDistanceToNow } from 'date-fns';

function ConversationList({ 
  conversations, 
  onSelectConversation, 
  selectedConversationId,
  onLoadMore,
  hasMore,
  isLoadingMore
}) {
  const observer = useRef();
  const [copiedId, setCopiedId] = useState(null);

  const lastConversationElementRef = useCallback(node => {
    if (isLoadingMore) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        onLoadMore();
      }
    });

    if (node) observer.current.observe(node);
  }, [isLoadingMore, hasMore, onLoadMore]);

  const handleCopy = (id) => {
    navigator.clipboard.writeText(id);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 1200);
  };

  if (!conversations || conversations.length === 0) {
    return null;
  }

  return (
    <>
      <ul className="conversation-list">
        {conversations.map((conv, index) => {
          const convKey = conv.conversationId || conv._id;
          const isLastElement = conversations.length === index + 1;
          return (
            <li 
              key={convKey} 
              ref={isLastElement ? lastConversationElementRef : null}
              className={`conversation-list-item ${selectedConversationId === convKey ? 'selected' : ''}`}
              onClick={() => onSelectConversation(convKey)}
            >
              <div className="conversation-title-row" style={{display: 'flex', alignItems: 'center', gap: 6}}>
                <div className="conversation-title">{conv.title || 'Untitled Conversation'}</div>
                {conv.conversationId && (
                  <button
                    className="copy-conversation-id-btn"
                    onClick={e => { e.stopPropagation(); handleCopy(conv.conversationId); }}
                    title="Copy Conversation ID"
                  >
                    {copiedId === conv.conversationId ? 'Copied!' : 'Copy ID'}
                  </button>
                )}
              </div>
              {conv.conversationId && (
                <div className="conversation-id-wrap">
                  <span className="conversation-id" style={{wordBreak: 'break-all', whiteSpace: 'normal'}}>{conv.conversationId}</span>
                </div>
              )}
              
              {/* Display User Name and Email if available */}
              {conv.userDetails ? (
                <>
                  <div className="conversation-user-name">User: {conv.userDetails.name || 'N/A'}</div>
                  <div className="conversation-user-email">Email: {conv.userDetails.email || 'N/A'}</div>
                </>
              ) : (
                conv.user && <div className="conversation-user">User ID: {conv.user}</div> // Fallback to original user field
              )}

              {conv.createdAt && (
                <div className="conversation-user"> 
                  Created: {formatDistanceToNow(new Date(conv.createdAt), { addSuffix: true })}
                </div>
              )}
            </li>
          );
        })}
      </ul>
      {isLoadingMore && <div className="loading-more-indicator">Loading more...</div>}
      {!hasMore && conversations.length > 0 && <div className="loading-more-indicator">No more conversations.</div>}
    </>
  );
}

export default ConversationList; 